//vendors
import React from 'react';
import ReactDOM from 'react-dom';
import { usePopperTooltip } from 'react-popper-tooltip';
import classNames from "classnames";

//styles
import styles from "./tooltip.module.scss";

type Props = {
  children: JSX.Element[] | JSX.Element,
  message: string | JSX.Element,
  placement: "top" | "bottom" | "right" | "left" | "top-start" | "top-end" | "bottom-start" | "bottom-end" | "right-start" | "right-end" | "left-start" | "left-end",
  trigger: 'click' | 'right-click' | 'hover' | 'focus' | null,
  dark?: boolean,
  delayShow?: number
};

export const Tooltip = (props: Props) => {
  const {
    getArrowProps,
    getTooltipProps,
    setTooltipRef,
    setTriggerRef,
    visible,
  } = usePopperTooltip({
    trigger: props.trigger,
    placement: props.placement,
    delayShow: props.delayShow
  });
  
  const renderTooltip = () => {
    if (!props.message && (props.message as string).length) {
      return null;
    }

    return  ReactDOM.createPortal(
      <div
        ref={setTooltipRef}
        {...getTooltipProps({
          className: classNames(styles.tooltipContainer, {[styles.dark]: props.dark}),
          'data-placement': props.placement
        })}
      >
        <div
          {...getArrowProps({
            className: classNames(styles.tooltipArrow, {[styles.dark]: props.dark}),
            'data-placement': props.placement
            /* your props here */
          })}
        />
        {props.message}
      </div>,
      document.body
    );
  };
  
  return (
    <>
      <div
        ref={setTriggerRef}
        className='trigger'
      >
        {props.children}
      </div>
  
      {visible && renderTooltip()}
    </>
  )
}

Tooltip.defaultProps = {
  trigger: 'hover',
  placement: 'auto',
  dark: false,
  delayShow: 500
}
